import { LeadConfiguration } from "../api/models/configuration";

export const getCustomerAddress = (
  configuration?: LeadConfiguration
): string => {
  const customer = configuration?.customer;
  let address = "";
  if (customer?.houseNumber) {
    address = customer?.houseNumber;
  }
  if (customer?.houseName) {
    address =
      address +
      (address?.endsWith(", ") && address ? "" : ", ") +
      customer?.houseName;
  }
  if (customer?.block) {
    address =
      address +
      (address?.endsWith(", ") && address ? "" : ", ") +
      customer?.block;
  }
  if (customer?.street) {
    address =
      address +
      (address?.endsWith(", ") && address ? "" : ", ") +
      customer?.street;
  }
  if (customer?.district) {
    address =
      address +
      (address?.endsWith(", ") && address ? "" : ", ") +
      customer?.district;
  }
  if (customer?.governorate) {
    address =
      address +
      (address?.endsWith(", ") && address ? "" : ", ") +
      customer?.governorate;
  }
  if (customer?.postalCode) {
    address =
      address +
      (address?.endsWith(", ") && address ? "  P.O Box  " : ",  P.O Box  ") +
      customer?.postalCode;
  }

  return address;
};

export const getCustomerAddressLine1 = (
  configuration?: LeadConfiguration
): string => {
  const customer = configuration?.customer;
  let address = "";

  if (customer?.block) {
    address =
      address +
      (address?.endsWith(", ") && address ? "" : ", ") +
      customer?.block;
  }

  return address;
};
export const getCustomerAddressLine2 = (
  configuration?: LeadConfiguration
): string => {
  const customer = configuration?.customer;
  let address = "";
  if (customer?.houseNumber) {
    address = customer?.houseNumber;
  }
  if (customer?.address) {
    address =
      address +
      (address?.endsWith(", ") && address ? "" : ", ") +
      customer?.address;
  }

  return address;
};

export const getCustomerAddressLine3 = (
  configuration?: LeadConfiguration
): string => {
  const customer = configuration?.customer;
  return customer?.street?.trim() || customer?.city?.trim() || "";
};

export const getCustomerAddressLine4 = (
  configuration?: LeadConfiguration
): string => {
  const customer = configuration?.customer;
  return customer?.area?.trim() || customer?.district?.trim() || "";
};

export const getCustomerAddressLine5 = (
  configuration?: LeadConfiguration
): string => {
  const customer = configuration?.customer;
  return customer?.governorate?.trim() || customer?.country?.trim() || "";
};

export const getStatusTag = (
  proposalDocuments?: any[],
  proposedPropertyId?: string
) => {
  const documents = proposalDocuments?.filter(
    (x) => x.proposedPropertyId === proposedPropertyId
  );

  const invoiceStage = documents?.filter((x) => x.stageCode === "invoice");
  if (invoiceStage?.filter((d)=>d.document?.paymentDetails || d.seperateDocumentForLandlord?.paymentDetails)?.length) {    
    return "Payment Collected";
  }
  if (invoiceStage?.filter((d)=>d.document || d.seperateDocumentForLandlord)?.length) {    
    return "Invoice Created";
  }
  const agreementStage = documents?.filter((x) => x.stageCode === "agreement");
  if (agreementStage?.filter((d)=>d.signedClientDocument && d.signedLandlordDocument)?.length) {    
    return "Agreement Signed By Client && Vendor";
  }
  if (agreementStage?.filter((d)=>d.signedClientDocument)?.length) {    
    return "Agreement Signed By Client";
  }
  if (agreementStage?.filter((d)=>d.signedLandlordDocument)?.length) {    
    return "Agreement Signed By Vendor";
  }
  if (agreementStage?.length) {    
    return "Agreement Created";
  }
  const loiStage = documents?.filter((x) => x.stageCode === "letter_of_intent");
  if (loiStage?.filter((d)=>d.signedClientDocument && d.signedLandlordDocument)?.length) {    
    return "Letter of Intent Signed By Client && Vendor";
  }
  if (loiStage?.filter((d)=>d.signedClientDocument)?.length) {    
    return "Letter of Intent Signed By Client";
  }
  if (loiStage?.filter((d)=>d.signedLandlordDocument)?.length) {    
    return "Letter of Intent Signed By Vendor";
  }
  if (loiStage?.length) {    
    return "Letter of Intent Created";
  }
  const feeConfirmation = documents?.filter((x) => x.stageCode === "fee_confirmation");
  if (feeConfirmation?.filter((d)=>d.signedClientDocument && d.signedLandlordDocument)?.length) {    
    return "Fee Letter Signed By Client && Vendor";
  }
  if (feeConfirmation?.filter((d)=>d.signedClientDocument)?.length) {    
    return "Fee Letter Signed By Client";
  }
  if (feeConfirmation?.filter((d)=>d.signedLandlordDocument)?.length) {    
    return "Fee Letter Signed By Vendor";
  }
  if (feeConfirmation?.length) {    
    return "Fee Letter Created";
  }

  const termSheet = documents?.filter((x) => x.stageCode === "term_sheet_submission");
  if (termSheet?.filter((d)=>d.signedClientDocument && d.signedLandlordDocument)?.length) {    
    return "Term Sheet Signed By Client && Vendor";
  }
  if (termSheet?.filter((d)=>d.signedClientDocument)?.length) {    
    return "Term Sheet Signed By Client";
  }
  if (termSheet?.filter((d)=>d.signedLandlordDocument)?.length) {    
    return "Term Sheet Signed By Vendor";
  }
  if (termSheet?.length) {    
    return "Term Sheet Created";
  }
  return ''
};
